import { Button, LoadingIndicator } from 'hem-ui';
import { Download } from 'lucide-react';
import React from 'react';

export const PreviewRefresh = () => {
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const handleRefresh = async () => {
    try {
      const res = await fetch(
        'http://localhost:8000/__refresh/gatsby-source-contentful',
        {
          method: 'POST',
        },
      );

      if (!res.ok) {
        throw new Error('Failed to refresh preview');
      }

      setIsRefreshing(true);
      setTimeout(() => setIsRefreshing(false), 20000);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        right: 20,
        bottom: 20,
        zIndex: 1000,
      }}
    >
      <Button
        onClick={handleRefresh}
        style={{
          padding: '3px 0px 0px 0px',
          height: 40,
          width: 40,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {isRefreshing ? <LoadingIndicator /> : <Download />}
      </Button>
    </div>
  );
};
